import { AutogenModelPartialShipmentManifestOrderDetails, AutogenRowPartialShipmentManifestOrderDetails } from "./autogen/AutogenModelPartialShipmentManifestOrderDetails";

export class ModelPartialShipmentManifestOrderDetails extends AutogenModelPartialShipmentManifestOrderDetails<RowPartialShipmentManifestOrderDetails> {
	constructor() {
		super(RowPartialShipmentManifestOrderDetails);
	}
}

export class RowPartialShipmentManifestOrderDetails extends AutogenRowPartialShipmentManifestOrderDetails {
}